import React, { useState, useCallback, useRef, useEffect } from 'react';
import { View, Text, TouchableOpacity, Image, ActivityIndicator } from 'react-native';
//import Carousel, { Pagination } from 'react-native-snap-carousel';
import { FontAwesome } from "@expo/vector-icons";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useIsFocused } from '@react-navigation/native';

import HeaderDefault from '../../components/HeaderDefault';
import ScreenLoader from '../../components/ScreenLoader'

import { toast } from '../../utils/toast';

import styles from './styles';
import api from '../../services/api';

const BankAccount = ({ navigation }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [cards, setCards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const ref = useRef(null);
    const isFocused = useIsFocused();

    useEffect(() => {
        getDataAccounts();
    }, [isFocused]);

    async function getDataAccounts() {
        setIsLoading(true);
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        api.get('/bank-accounts', { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                var accounts = [];

                res.data.data.map(item => {
                    accounts.push({
                        bank: item.bank.bank,
                        bankId: item.bank.id,
                        typeAccount: item.bank_account_type.name,
                        typeAccountId: item.bank_account_type_id,
                        agency: item.branch,
                        account: item.account,
                        id: item.id
                    })
                })

                setCards(accounts);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error)
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }

    const renderItem = useCallback(({ item, index }) => {
        return (
            <View style={styles.contentCard}>
                <TouchableOpacity
                    style={styles.contentEdit}
                    onPress={() => navigation.navigate('EditBankAccount', { item })}
                >
                    <FontAwesome name="edit" size={24} color="#000" />
                </TouchableOpacity>

                <Text style={styles.textInfo}>Banco: {' '}
                    <Text style={styles.textDescription}>{item.bank}</Text>
                </Text>
                <Text style={styles.textInfo}>Tipo de conta: {' '}
                    <Text style={styles.textDescription}>{item.typeAccount}</Text>
                </Text>
                <Text style={styles.textInfo}>Agência: {' '}
                    <Text style={styles.textDescription}>{item.agency}</Text>
                </Text>
                <Text style={styles.textInfo}>Conta: {' '}
                    <Text style={styles.textDescription}>{item.account}</Text>
                </Text>

                <Image source={require('../../../assets/bank.png')} style={styles.imgBank} />
            </View>
        );
    }, []);


    return (
        <>
            <ScreenLoader loading={isLoading} />

            <HeaderDefault title={'Conta bancária'} />
            <View style={styles.container}>
                <TouchableOpacity style={styles.btnAdd} onPress={() => navigation.navigate('NewBankAccount')}>
                    <Text style={styles.textBtn}>ADICIONAR CONTA</Text>
                </TouchableOpacity>

                {
                    cards.length === 0 ? (
                        <Text style={styles.textNotFoundAccounts}>Nenhuma conta foi encontrada.</Text>
                    ) : (
                        <View>
                            {
                                cards.map((item, index) =>
                                    <View style={styles.contentCard} key={index}>
                                        <TouchableOpacity
                                            style={styles.contentEdit}
                                            onPress={() => navigation.navigate('EditBankAccount', { item })}
                                        >
                                            <FontAwesome name="edit" size={24} color="#000" />
                                        </TouchableOpacity>

                                        <Text style={styles.textInfo}>Banco: {' '}
                                            <Text style={styles.textDescription}>{item.bank}</Text>
                                        </Text>
                                        <Text style={styles.textInfo}>Tipo de conta: {' '}
                                            <Text style={styles.textDescription}>{item.typeAccount}</Text>
                                        </Text>
                                        <Text style={styles.textInfo}>Agência: {' '}
                                            <Text style={styles.textDescription}>{item.agency}</Text>
                                        </Text>
                                        <Text style={styles.textInfo}>Conta: {' '}
                                            <Text style={styles.textDescription}>{item.account}</Text>
                                        </Text>

                                        <Image source={require('../../../assets/bank.png')} style={styles.imgBank} />
                                    </View>

                                )
                            }
                            {/* <Carousel
                                    layout={"default"}
                                    ref={ref}
                                    data={cards}
                                    sliderWidth={400}
                                    itemWidth={350}
                                    renderItem={renderItem}
                                    onSnapToItem={index => setActiveIndex(index)}
                                /> */}
                        </View>
                    )
                }
            </View>
        </>
    );
}

export default BankAccount;